import PropTypes from 'prop-types';
import React from 'react';

const Footer = (props) => (
	<footer
		className={`bsknacht17-page-footer js-bsknacht17-state--${props.view}`}
	>
		<p className="bsknacht17-page-footer__left">
			<a href="https://www.braunschweig.de/kulturnacht/">
				<span>Weitere Infos zur Kulturnacht</span>
			</a>
		</p>
		<p className="bsknacht17-page-footer__right">
			<a href="https://de-de.facebook.com/BSKulturnacht/">
				<span>Zur Kulturnacht-Fanpage</span>

				<svg
					width="24px"
					height="24px"
					viewBox="0 0 24 24"
					version="1.1"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M18.8916,7.4629 L17.2996,7.4629 C16.0516,7.4629 15.8086,8.0569 15.8086,8.9279 L15.8086,10.8479 L18.7876,10.8479 L18.3986,13.8559 L15.8086,13.8559 L15.8086,21.5699 L12.7036,21.5699 L12.7036,13.8559 L10.1056,13.8559 L10.1056,10.8479 L12.7036,10.8479 L12.7036,8.6309 C12.7036,6.0569 14.2736,4.6539 16.5706,4.6539 C17.6716,4.6539 18.6156,4.7359 18.8916,4.7739 L18.8916,7.4629 Z M20.3396,-0.0001 L3.6466,-0.0001 C1.6326,-0.0001 -0.0004,1.6309 -0.0004,3.6449 L-0.0004,20.3379 C-0.0004,22.3519 1.6326,23.9829 3.6466,23.9829 L20.3396,23.9829 C22.3536,23.9829 23.9826,22.3519 23.9826,20.3379 L23.9826,3.6449 C23.9826,1.6309 22.3536,-0.0001 20.3396,-0.0001 L20.3396,-0.0001 Z"
						fill="white"
						stroke="none"
						fillRule="evenodd"
					/>
				</svg>
			</a>
		</p>

		<p className="bsknacht17-page-footer__small-print">
			<a href="https://www.braunschweig.de/impressum.html" rel="external">
				<span>Impressum und Bildnachweis</span>
			</a>
			, Karte: © Stadt Braunschweig und{' '}
			<a href="https://www.openstreetmap.org/" rel="external">
				<span>OpenStreetMap</span>
			</a>{' '}
			(
			<a href="https://opendatacommons.org/licenses/odbl/" rel="external">
				<span>Open Database License</span>
			</a>
			)<br />
			Konzept & Umsetzung:{' '}
			<a href="https://neonaut.de/">
				<span>Neonaut GmbH</span>
			</a>
		</p>
	</footer>
);

Footer.propTypes = {
	view: PropTypes.string.isRequired,
};

export default Footer;
